import { wrap, Tooltip } from 'highcharts'

export const client = () => {
	wrap(Tooltip.prototype, 'hide', function(defaultCallback) {
		if (this.chart.userOptions.chart.type !== 'solidgauge') {
			defaultCallback.apply(this, Array.prototype.slice.call(arguments, 1))
		}
	})
}
